import {
  CONTACT_DETAIL_FETCH,
  CONTACT_DETAIL_SUCCESS,
  CONTACT_DETAIL_FAILURE
} from './actionTypes';

const initialState = {
  isLoaded: false,
  error: []
};

export const contactDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONTACT_DETAIL_FETCH:
      return { ...state, isLoaded: false };
    case CONTACT_DETAIL_SUCCESS:
      return { ...state, isLoaded: true };
    case CONTACT_DETAIL_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/ContactDetail/reducer.js